module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('h1', {
    domProps: {
      "innerHTML": _vm._s(_vm.name)
    }
  }), _vm._v(" "), _c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.description)
    }
  }), _vm._v(" "), _c('div', {
    class: ['table-layout']
  }, [_c('div', [_c('div', [_c('h2', [_vm._v("Default")]), _vm._v(" "), _c('vc-piechart', {
    attrs: {
      "data": _vm.data1
    }
  })], 1), _vm._v(" "), _c('div', [_c('h2', [_vm._v("Customized Via Props")]), _vm._v(" "), _c('vc-piechart', {
    attrs: {
      "data": _vm.data2,
      "size": "12em",
      "legend": true,
      "title": "Chart 2",
      "donut": true,
      "flat": false
    }
  })], 1)])]), _vm._v(" "), _c('h2', [_vm._v("Installation")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('h2', [_vm._v("Usage")]), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('h2', [_vm._v("Props")]), _vm._v(" "), _c('ul', [_c('li', [_c('code', [_vm._v("data (Array)")]), _vm._v(": chart data (default: "), _c('code', [_vm._v("[]")]), _vm._v("):"), _c('pre', [_c('code', [_vm._v(_vm._s(_vm.data1))])])]), _vm._v(" "), _vm._m(4), _vm._v(" "), _vm._m(5), _vm._v(" "), _vm._m(6), _vm._v(" "), _vm._m(7), _vm._v(" "), _vm._m(8)]), _vm._v(" "), _c('p', [_vm._v("Version " + _vm._s(_vm.version) + " developed by "), _c('a', {
    attrs: {
      "href": "https://wemakesites.net/",
      "target": "_blank"
    }
  }, [_vm._v("Martin Ivanov")]), _vm._v(" and available on\n      "), _c('a', {
    attrs: {
      "href": "https://bitbucket.org/acidmartin/vc-piechart/",
      "target": "_blank"
    }
  }, [_vm._v("BitBucket")]), _vm._v(" and\n      "), _c('a', {
    attrs: {
      "href": "https://www.npmjs.com/package/vc-piechart",
      "target": "_blank"
    }
  }, [_vm._v("NPM")]), _vm._v(".")]), _vm._v(" "), _c('vc-social-bar', {
    attrs: {
      "title": _vm.name,
      "position": "right",
      "services": _vm.services
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pre', [_c('code', [_vm._v("$ npm i vc-piechart --save")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pre', [_c('code', [_vm._v("// in main.js, use globally\nimport VcPiechart from 'vc-piechart'\nimport 'vc-piechart/dist/lib/vc-piechart.min.css'\nVue.use(VcPiechart)\n\n// as a component in another component\nimport VcPiechart from 'vc-piechart'\nimport 'vc-piechart/dist/lib/vc-piechart.min.css'\n\nexport default {\n  name: 'app',\n  components: {\n    VcPiechart\n  }\n}")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pre', [_c('code', [_vm._v("<vc-piechart :data=\"data1\" />")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pre', [_c('code', [_vm._v("<vc-piechart :data=\"data2\" size=\"12em\" :legend=\"true\"  title=\"Chart 2\" :donut=\"true\" :flat=\"false\" />")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('code', [_vm._v("size (String)")]), _vm._v(": chart's height and width in "), _c('code', [_vm._v("px")]), _vm._v(", "), _c('code', [_vm._v("em")]), _vm._v(", etc. default: "), _c('code', [_vm._v("256px")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('code', [_vm._v("legend (Boolean)")]), _vm._v(": toggle chart's legend element (default: "), _c('code', [_vm._v("true")]), _vm._v(")")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('code', [_vm._v("title (String)")]), _vm._v(": optional chart title (default: "), _c('code', [_vm._v("null")]), _vm._v(")")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('code', [_vm._v("donut (Boolean)")]), _vm._v(": toggle the donut mode (default: "), _c('code', [_vm._v("false")]), _vm._v(")")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('code', [_vm._v("flat (Boolean)")]), _vm._v(": toggle chart's drop-shadow (default: "), _c('code', [_vm._v("false")]), _vm._v(")")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1212d0bb","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app.vue
// module id = 22
// module chunks = 0